<template>
  <footer class="mt-auto overflow-hidden">
    <v-sheet color="primary" class="py-10 py-md-12 item">
      <div class="container">
        <v-row justify="center">
          <v-col cols="12" md="4" lg="3" class="text-center">
            <router-link to="/">
              <img
                :src="files + informations.img"
                :alt="informations.name"
                class="d-inline-block filter-white"
                height="88px"
              />
            </router-link>

            <div class="d-flex justify-center mt-6">
              <v-btn
                rounded
                depressed
                height="42px"
                min-width="auto"
                width="42px"
                :href="link"
                target="_blank"
                color="primary lighten-3"
                class="white--text"
                :class="{ 'ml-3': keySocial > 0 }"
                :title="title"
                v-for="({ title, link, icon, size }, keySocial) in media"
                :key="keySocial"
              >
                <v-icon :size="size"> {{ icon }} </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row
          justify="center"
          justify-md="space-around"
          justify-lg="space-between"
        >
          <v-col cols="9" sm="6" md="5" lg="auto" class="mt-8">
            <div class="d-inline-flex item-title">
              <Title small light> Atendimento </Title>
            </div>

            <div class="d-flex flex-column mt-5">
              <div
                v-for="(contactItem, contactKey) in contact"
                :key="contactKey"
              >
                <div class="mx-n3" v-if="!Array.isArray(contactItem)">
                  <a
                    v-ripple
                    class="
                      d-inline-flex
                      text-none text-decoration-none
                      px-3
                      py-2
                    "
                    :class="[contactItem.colorTitle]"
                    :href="contactItem.link"
                    :target="contactItem.target"
                  >
                    <v-sheet
                      color="transparent"
                      width="20px"
                      class="mr-2 text-center"
                    >
                      <v-icon
                        class="primary--text text--lighten-3"
                        :size="contactItem.size"
                      >
                        {{ contactItem.icon }}
                      </v-icon>
                    </v-sheet>

                    <span :class="[contactItem.sizeTitle]">
                      {{ contactItem.title }}
                    </span>
                  </a>
                </div>
                <div v-else>
                  <div
                    class="mx-n3"
                    v-for="(
                      {
                        title,
                        colorTitle,
                        sizeTitle,
                        link,
                        target,
                        icon,
                        size,
                      },
                      key
                    ) in contactItem"
                    :key="key"
                  >
                    <a
                      v-ripple
                      class="
                        d-inline-flex
                        text-none text-decoration-none
                        px-3
                        py-2
                      "
                      :class="[colorTitle]"
                      :href="link"
                      :target="target"
                    >
                      <v-sheet
                        color="transparent"
                        width="20px"
                        class="mr-2 text-center"
                      >
                        <v-icon
                          class="primary--text text--lighten-3"
                          :size="size"
                        >
                          {{ icon }}
                        </v-icon>
                      </v-sheet>
                      <span :class="[sizeTitle]" v-html="title">
                        {{ title }}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div class="mx-n3">
                  <router-link
                    v-ripple
                    to="/politica-de-privacidade"
                    class="
                      d-inline-flex
                      white--text
                      text-none text-decoration-none
                      px-3
                      py-2
                      item-link
                    "
                  >
                    <v-sheet
                      color="transparent"
                      width="20px"
                      class="mr-2 text-center"
                    >
                      <v-icon class="primary--text text--lighten-3" size="18">
                        fa-shield
                      </v-icon>
                    </v-sheet>

                    <span class="primary--text text--lighten-3">
                      Política de Privacidade
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="9" sm="6" md="5" lg="auto" class="mt-8">
            <div class="d-inline-flex item-title">
              <Title small light> Social </Title>
            </div>

            <div class="d-flex flex-column mt-5">
              <div
                v-for="({ title, to }, socialKey) in social"
                :key="socialKey"
              >
                <div class="mx-n3">
                  <router-link
                    v-ripple
                    class="
                      d-inline-flex
                      primary--text
                      text--lighten-3 text-none text-decoration-none
                      px-3
                      py-2
                      item-link
                    "
                    :to="to"
                  >
                    <v-icon
                      class="primary--text text--lighten-3 mr-2"
                      size="4px"
                    >
                      fa-circle
                    </v-icon>

                    <span v-html="title"></span>
                  </router-link>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="9" sm="6" md="5" lg="auto" class="mt-8">
            <div class="d-inline-flex item-title">
              <Title small light> Serviços </Title>
            </div>

            <div class="d-flex flex-column mt-5">
              <div
                v-for="({ title, to }, serviceKey) in services"
                :key="serviceKey"
              >
                <div class="mx-n3">
                  <router-link
                    v-ripple
                    class="
                      d-inline-flex
                      primary--text
                      text--lighten-3 text-none text-decoration-none
                      px-3
                      py-2
                      item-link
                    "
                    :to="to"
                  >
                    <v-icon
                      class="primary--text text--lighten-3 mr-2"
                      size="4px"
                    >
                      fa-circle
                    </v-icon>

                    <span v-html="title"></span>
                  </router-link>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="9" sm="6" md="5" lg="auto" class="mt-8">
            <div class="d-inline-flex item-title">
              <Title small light> Projetos </Title>
            </div>

            <div class="d-flex flex-column mt-5">
              <div>
                <div class="mx-n3">
                  <router-link
                    v-ripple
                    class="
                      d-inline-flex
                      primary--text
                      text--lighten-3 text-none text-decoration-none
                      px-3
                      py-2
                      item-link
                    "
                    to="/projetos/espaco-cultural"
                  >
                    <v-icon
                      class="primary--text text--lighten-3 mr-2"
                      size="4px"
                    >
                      fa-circle
                    </v-icon>

                    <span>Espaço Cultural</span>
                  </router-link>
                </div>
              </div>
              <div
                v-for="({ title, to }, projectKey) in projects"
                :key="projectKey"
              >
                <div class="mx-n3">
                  <router-link
                    v-ripple
                    class="
                      d-inline-flex
                      primary--text
                      text--lighten-3 text-none text-decoration-none
                      px-3
                      py-2
                      item-link
                    "
                    :to="to"
                  >
                    <v-icon
                      class="primary--text text--lighten-3 mr-2"
                      size="4px"
                    >
                      fa-circle
                    </v-icon>

                    <span v-html="title"></span>
                  </router-link>
                </div>
              </div>
              <div>
                <div class="mx-n3">
                  <router-link
                    v-ripple
                    class="
                      d-inline-flex
                      primary--text
                      text--lighten-3 text-none text-decoration-none
                      px-3
                      py-2
                      item-link
                    "
                    to="/projetos/nasci-no-h2p"
                  >
                    <v-icon
                      class="primary--text text--lighten-3 mr-2"
                      size="4px"
                    >
                      fa-circle
                    </v-icon>

                    <span>Nasci no Dois Pinheiros</span>
                  </router-link>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-sheet>

    <v-sheet class="primary darken-1">
      <div class="container py-0">
        <v-sheet
          min-height="60px"
          class="
            transparent
            white--text
            d-flex
            justify-space-between
            align-center
            flex-column flex-sm-row
            py-4 py-sm-0
          "
        >
          <v-row justify="space-between">
            <v-col cols="12" sm="auto">
              <div class="text-center copyright">
                Copyright @ {{ year }} <b>{{ informations.short_name }}</b
                >. Todos os Direitos Reservados.
                <!-- CNPJ: 14.931.414/0001-49 - Hospital e Maternidade Dois Pinheiros
                LTDA - EPP - Copyright @ {{ year }} -->
              </div>
            </v-col>
            <v-col cols="12" sm="auto">
              <a href="https://mrxweb.com.br/" target="_blank">
                <img
                  class="mx-auto mx-sm-0 d-block"
                  src="/img/mrxweb.svg"
                  height="20px"
                  alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
                  title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
                />
              </a>
            </v-col>
          </v-row>
        </v-sheet>
      </div>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact, getSocial } from "../../config";
import { formatToURL } from "../../utils/formatToURL";
import Title from "../widgets/Title.vue";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return this.$rest("social").list.map(({ id, title }) => ({
        title,
        to: `/social/${formatToURL(title)}-${id}`,
      }));
    },
    projects() {
      return this.$rest("projects-topics").list.map(({ id, title }) => ({
        title,
        to: `/projetos/${formatToURL(title)}-${id}`,
      }));
    },
    services() {
      return this.$rest("services").list.map(({ id, title }) => ({
        title,
        to: `/servicos/${formatToURL(title)}-${id}`,
      }));
    },
    medias() {
      return this.$rest("informations-medias").item;
    },
    contacts() {
      return this.$rest("informations-contacts").item;
    },
    media() {
      return getSocial(this.medias);
    },
    contact() {
      return getContact(this);
    },
  },
  mounted() {
    this.$rest("informations-medias").get({
      save: (state, data) => (state.item = data),
    });

    this.$rest("informations-contacts").get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    Title,
  },
};
</script>

<style lang="scss" scoped>
.container {
  @media screen and (max-width: 1199px) {
    max-width: 100% !important;
  }
}

.item {
  .item-link {
    white-space: pre-wrap !important;
  }
  .social-btn {
    transition: all 0.1s linear;
    &:hover {
      background-color: var(--v-primary-base) !important;
      border-color: var(--v-primary-base) !important;
      color: #ffffff !important;
    }
  }
}
</style>
